import instances from './map';
import generateToken  from './generateToken';

/*
export const createProcedure_ME = async params => {
  await generateToken_ME('procedimentov2');

  const data = {};
  const { credenId, planId, isoProcedureID, face, tooth, region } = params;

  !!face && Object.assign(data, { face });
  !!tooth && Object.assign(data, { tooth });
  !!region && Object.assign(data, { region });
  !!isoProcedureID && Object.assign(data, { isoProcedureID });

  return instances
    .procedimentov2({
      method: 'POST',
      url: `/credenciados/${credenId}/planos/${planId}/procedimentos`,
      data
    })
    .then(() => ({ credenId, planId }))
    .catch(err => {
      if (err.response.data.message.description) {
        return Promise.reject(new Error(err.response.data.message.description));
      }

      return Promise.reject(new Error('Não foi possível criar o procedimento solicitado'));
    });
};
*/
/*
export const deleteProcedure_ME = async params => {
  await generateToken_ME('prestador_excluir_ME');
  const { credenId, planId, procedureId } = params;
  return instances
    .prestador_excluir_ME({
      method: 'DELETE',
      url: `/credenciados/${credenId}/planos/${planId}/procedimentos/${procedureId}`
    })
    .then(res => ({ credenId, planId, procedureId }))
    .catch(err => Promise.reject(new Error(err.message)));
};
*/
/*
export const updateProcedure_ME = async params => {
  await generateToken_ME('procedimentov2');

  const { credenId, planId, procedureId, face, tooth, region, isoProcedureID } = params;

  const data = {
    face: face || null,
    tooth: tooth || null,
    region: region || null,
    isoProcedureID: isoProcedureID || null
  };

  return instances
    .procedimentov2({
      method: 'PUT',
      url: `/credenciados/${credenId}/planos/${planId}/procedimentos/${procedureId}`,
      data
    })
    .then(res => {
      ({ credenId, planId });
    })
    .catch(err => Promise.reject(new Error(err.response.data.message.description)));
};
*/
/*
export const closePlan_ME = ({ credenId, planId }) =>
  instances
    .procedimentov2({
      method: 'PATCH',
      url: `/credenciados/${credenId}/planos/${planId}`
    })
    .then(res => res.data.data)
    .catch(err => {
      console.error(err.message);
      return Promise.reject(new Error('Não foi possível encerrar este plano de tratamento'));
    });
*/
/*
const requestPlanImages = item =>
  instances
    .procedimentov2({
      method: 'GET',
      url: `procedimentos/${item.procedureId}/imagens/${item.imageId}?isThumbnail=true`
    })
    .then(res => {
      const obj = {
        imageId: item.imageId,
        imageTitle: item.imageTitle,
        procedureId: item.procedureId,
        src: `data:image/png;base64,${res.data}`
      };

      return obj;
    })
    .catch(err => Promise.reject(err));
*/
/*
export const getPlanImages_ME = async item => {
  await generateToken_ME('procedimentov2');

  const promises = item.images.map(requestPlanImages);
  return Promise.all(promises)
    .then(thumb => thumb)
    .catch(err => Promise.reject(err));
};
*/
/**
 * API: "Busca o base64 para montagem do PDF de uma GTO"
 * @param(gtoId) numero da GTO
 */
export const getPDFGTO = async ({ gtoId }) => {
  await generateToken('procedimento_odonto_v2');

  return instances
    .procedimento_odonto_v2({
      method: 'GET',
      url: `/guias-tratamento/${gtoId}/pdf`
    })
    .then(res => Promise.resolve(res))
    .catch(err => {
      console.error('Erro ao buscar o PDF', err.message);
      return Promise.reject(
        new Error('Não foi possível buscar o PDF no momento, tente novamente mais tarde.')
      );
    });
};

export const getGtoDetails = async gtoId => {
  await generateToken('procedimento_odonto_v1');

  return instances
    .procedimento_odonto_v1({
      method: 'GET',
      url: '/guias-tratamento',
      params: {
        pOrcamento: gtoId
      }
    })
    .then(res => Promise.resolve(res))
    .catch(err => {
      console.error('Erro ao buscar o PDF', err.message);
      return Promise.reject(
        new Error('Não foi possível buscar o PDF no momento, tente novamente mais tarde.')
      );
    });
};

export const getProceduresTypes = description =>
  instances.procedimento_odonto_v1({
    method: 'GET',
    url: '/procedimentos',
    params: {
      pProcedimento: description
    }
  });

export const toothRegion = ({ procedureId, tooth }) =>
  instances.procedimento_odonto_v1({
    url: `/procedimentos/${procedureId}`,
    params: {
      pCodProcedimento: procedureId,
      pDenteFace: tooth
    }
  });

export const validateProc = async ({ procedureId, tooth }) => {
  try {
    await generateToken('procedimento_odonto_v1');
    const possibleToothRegion = await toothRegion({ procedureId, tooth });

    return { ...possibleToothRegion.data };
  } catch (e) {
    throw new Error(e.message);
  }
};

export const getProceduresTypesWithToken = async description => {
  try {
    await generateToken('procedimento_odonto_v1');
    const procedures = await getProceduresTypes(description);

    if (procedures.data.mensagemErro && procedures.data.mensagemErro.codigo === 999) {
      return Promise.reject(new Error('Procedimento não encontrado'));
    }

    return procedures.data.procedimentos;
  } catch (e) {
    console.error(e);
    const { details, result, status } = e.response.data;
    const msg = `${result} - ${status}\n${details}`;
    throw new Error(msg);
  }
};

export const cancelGTO = async ({ gtoId, procedimentos }) => {
  await generateToken('procedimento_odonto_v2');

  return instances
    .procedimento_odonto_v2({
      method: 'POST',
      url: `/guias-tratamento/${gtoId}/procedimento/cancelamento`,
      data: procedimentos
    })
    .then(res => Promise.resolve(res))
    .catch(err => {
      console.error('Erro ao buscar o PDF', err.message);
      return Promise.reject(
        new Error('Não foi possível buscar o PDF no momento, tente novamente mais tarde.')
      );
    });
};

export default {
  getPDFGTO,
  getGtoDetails,
  getProceduresTypesWithToken,
  validateProc,
  cancelGTO
};
